import React, { useEffect, useState }  from 'react';
import { Link } from "react-router-dom";
import { Button } from 'semantic-ui-react'
import InfiniteScroll from 'react-infinite-scroll-component';

import useApiService from '../../services/useApiService';

import SemanticUiModal from '../../components/modal';
import ElementLoader from '../../components/element_loader';

import { createRiskUrl, getText } from '../../helpers'

function UtilisationItem(props) {
  const { risk } = props;
  const metadata = JSON.parse(risk.metadata);
  const destination = createRiskUrl(metadata, risk.plan_id);
  const countDescription = `x${risk.controls.length}`;

  return (
    <tr className="utilisation-item">
      <td className="risk-id">{risk.id}</td>
      <td>
        <span className="section plan-name">{risk.plan_name}</span>
        <span className="divider">/</span>
        <span className="section">{metadata.work_phase_or_ambient_exposure}</span>
        <span className="divider">/</span>
        <span className="section">{metadata.activity}</span>
        <span className="divider">/</span>
        <span className="section">{metadata.hazard}</span>
        <span className="divider">/</span>
        <span className="section">{metadata.unwanted_event}</span>
        {
          risk.controls.length > 1 && <span className="section"><strong> ({countDescription})</strong></span>
        }
      </td>
      <td><Link className="link text-light-blue" to={destination} target="_blank">{getText("View Risk")}</Link></td>
    </tr>
  )
}

function UtilisationHeader(props) {
  const {control} = props;

  return (
    <div>
      <span>{getText("Control Utilisation")} - </span>
      <span className='control-details'>
        <span className='static-custom-id'>{control.custom_id}</span>
        <span className='control-title'>{control.title}</span>
      </span>
    </div>
  )
}

function UtilisationContent(props) {
  const perPage = 20;
  const { libraryControlId } = props;
  const [ risks, setRisks ] = useState([]);
  const [ page, setPage] = useState(1);
  const [{ isLoading, response: fetchedRisks }, getRisks] = useApiService({ url: `/library_controls/${libraryControlId}/risks`, defaultResponse: [] });

  const setNewPage = () => {
    if (fetchedRisks.length < perPage) return;
    setPage(page + 1)
  }

  useEffect(()=>{
    getRisks({ params: { per_page: perPage, page } });
  }, [page])

  useEffect(()=>{
    setRisks(risks.concat(fetchedRisks));
  }, [fetchedRisks])

  return (
    <InfiniteScroll
      dataLength={risks.length}
      next={setNewPage}
      hasMore={true}
      height={1}
    >
      <table className="utilisation-table table">
        <thead>
          <tr>
            <th className="risk-id-header">{getText("Risk ID")}</th>
            <th>{getText("Risk Details")}</th>
            <th className="actions-header"></th>
          </tr>
        </thead>
        {
          risks && risks.length ?
          <tbody>
            {
              risks.map((risk, index)=>{
                return <UtilisationItem risk={risk}/>
              })
            } 
          </tbody>
          :
          <tbody>
            <tr>
              <td colspan="3" className='no-records'>{getText("No related records found.")}</td>
            </tr>
          </tbody>
        }
        <ElementLoader isLoading={isLoading} message={`${getText("Fetching related risks")}...`} />
      </table>
    </InfiniteScroll>
  )
}

function UtilisationActions(props) {
  return (
    <div>
      <Button fluid size='medium' className="new-plan-button" onClick={props.hideControlUtilisation}>
        {getText("Close")}
      </Button>
    </div>
  )
}

function LibraryControlUtilisation(props) {
  const { control, hideControlUtilisation } = props
  const modalOptions = { className: "control-utilisation", size: "tiny" }
  return (
    <SemanticUiModal
      modalOptions={modalOptions}
      header={<UtilisationHeader control={control}/>}
      content={<UtilisationContent libraryControlId={control.id}/>}
      actions={<UtilisationActions hideControlUtilisation={hideControlUtilisation}/>}
      closeModal={hideControlUtilisation}
    />
  )
}

export default LibraryControlUtilisation;


// WEBPACK FOOTER //
// ./src/views/control_library/library_control_utilisation.js